// import React from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   IconButton,
//   Chip,
//   Divider,
//   CircularProgress,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// const getProviderIcon = (providerType: string): string => {
//   switch (providerType.toUpperCase()) {
//     case 'GCP': return '/icons/google-cloud-icon-2048x1646-7admxejz.svg';
//     case 'AWS': return '/icons/aws.png';
//     case 'AZURE': return '/icons/azure.svg';
//     default: return '';
//   }
// };

// const getStatusChip = (status: string) => {
//     const commonSx = {
//         variant:'outlined' ,
//         height: '28px', 
//         borderRadius: '40px',
//         fontWeight: 400,
//         width:'67px'
        
//     };
//     switch (status?.toLowerCase()) {
//         case 'invalid': 
//             return <Chip 
//                 label="Invalid" 
//                 variant="outlined" 
//                 size="small"
//                 sx={{ 
//                     ...commonSx,
//                     color: '  #CA2B20', 
//                     borderColor: ' #F9E9E8',
//                     pointerEvents: 'none',
//                     border:'1px solid #CA2B20' 
//                 }} 
//             />;
//         case 'valid': 
//             return <Chip 
//                 label="Valid" 
//                 size="small"
//                 sx={{ 
//                     ...commonSx,
//                     backgroundColor: ' #E5F6EE', 
//                     color:' #03A65A',
//                     pointerEvents: 'none',
//                     border:'1px solid #03A65A'
//                 }} 
//             />;
//         case 'pending': 
//             return <Chip 
//                 label="Pending" 
//                 size="small"
//                 sx={{ 
//                     ...commonSx,
//                     backgroundColor: 'rgba(255, 243, 224, 1)', 
//                     color: 'rgba(255, 152, 0, 1)',
//                     border:'1px solid rgba(255, 152, 0, 1)',
//                     pointerEvents: 'none'

//                 }} 
//             />;
//         default: 
//             return <Chip 
//                 label={status} 
//                 size="small"
//                 sx={{
//                     ...commonSx,
//                     backgroundColor: 'grey.200', 
//                     pointerEvents: 'none',
//                     color: 'grey.800',
//                 }} 
//             />;
//     } 
// };

// interface DataSource {
//   id: string;
//   name: string;
//   providerType: 'GCP' | 'AWS' | 'AZURE' | string;
//   validationStatus: 'Valid' | 'Invalid' | 'Pending' | string;
// }

// interface DeleteDataSourceDialogProps {
//   open: boolean;
//   onClose: () => void;
//   onConfirm: () => void;
//   dataSource: DataSource | null;
//   isDeleting: boolean;
// }

// const DeleteDataSourceDialog: React.FC<DeleteDataSourceDialogProps> = ({ open, onClose, onConfirm, dataSource, isDeleting }) => {
//   if (!dataSource) {
//     return null;
//   }

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           fontFamily:'Inter',
//           width: 600, 
//           height: 411, 
//           borderRadius: '16px', 
//           p: '0.5rem',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'flex-start',
//           // overflow: 'hidden', // Ensures gradient respects the border radius

//           // --- START: GRADIENT ADDED HERE ---
//           // Replace 'card-gradient.svg' with your actual gradient file name
//           backgroundImage: `url('/textures/red-card-group.svg')`,
//           backgroundRepeat: 'no-repeat',
//           backgroundPosition: 'top center',
//           backgroundSize: '100% auto',
//           // --- END: GRADIENT ADDED HERE ---
//         },
//       }}
//     >
//       <DialogTitle sx={{ p: '1rem', flexShrink: 0 ,mt:'15px' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
//           <Box sx={{
//             fontFamily:'Inter',
//             width: '56px', 
//             height: '56px',
//             borderRadius: '10px', 
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             background: ' #F9E9E8',
//             flexShrink: 0,
//           }}>
//             <img src="/icons/delete_icon.svg" alt="Delete" style={{ width: '23.33px', height: '23.33px',fontFamily:'Inter' }} />
//           </Box>
//           <Typography variant="h6" component="div" sx={{ fontWeight: 600, flexGrow: 1, fontSize: '16px' ,fontFamily:'Inter', lineHeight: '24px', color:'rgba(51, 51, 51, 1)' }}>
//             Delete Data Source
//           </Typography>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ p: '1rem',mt:'24px' }}>
//         <Typography 
//           variant="body1" 
//           sx={{
//             fontFamily: 'Inter',
//             fontWeight: 600,
//             fontSize: '14px',
//             lineHeight: '20px',
//             letterSpacing: 'normal',
//             mb: '0.65rem',
//           }}
//         >
//           Do you want to delete this data source?
//         </Typography>
//         <Typography variant="body2" fontFamily='Inter' color=" #666666" sx={{ mb: '1.5rem',fontSize: '13px', lineHeight: '20px', fontWeight: 400 }}>
//             Once you delete this data source, it will be permanently removed from the system.
//         </Typography>
//         <Box
//           sx={{
//             border: '1px solid',
//             borderColor: '#F9FAFB',
//             backgroundColor: '#F9FAFB', 
//             borderRadius: '0.5rem',
//             p: '1rem',
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             width: '552px',
//             height:'67px'
//           }}
//         >
//           <Box>
//             <Typography variant="subtitle1" sx={{ fontWeight: 500,fontSize:'14px',lineHeight:'21px',color:' #333333' }}>
//               {dataSource.name}
//             </Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', mt: '0.25rem' }}>
//             <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 400,fontSize:'12px',lineHeight:'21px',color:' #666666' }}>
//                 Provider:
//             </Typography>
//                 <img 
//                 src={getProviderIcon(dataSource.providerType)} 
//                 alt={`${dataSource.providerType} logo`} 
//                 style={{ height: '1rem', width: 'auto' }} 
//                 />
//             </Box>
//           </Box>
//           {getStatusChip(dataSource.validationStatus)}
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ p: '1rem', gap: '0.50rem', flexShrink: 0 }}>
//         <Button
//           onClick={onClose}
//           disabled={isDeleting}
//           sx={{
//             fontFamily:'Inter',
//             textTransform: 'none',
//             borderRadius: '0.5rem',
//             // borderColor: 'grey.900',
//             color: ' #CA2B20',
//             py: '0.5rem',
//             width:'79px',
//             height: '36px', 
//             backgroundColor:' #FCF4F4',
//             fontWeight: 500,
//             fontSize:'14px'

//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={onConfirm}
//           disabled={isDeleting}
//           sx={{
//             width: '162px',
//             height: '36px',
//             borderRadius: '8px',
//             backgroundColor: '#CA2B20',
//             padding: '10px 16px',
//             gap: '4px',
//             fontFamily:'Inter',
//             textTransform: 'none',
//             fontWeight: 500,
//             fontSize:'14px',
//             color:' #FFFFFF'
//           }}
//         >
//           {isDeleting ? <CircularProgress size={14}color="inherit" /> : 'Delete Data Source'}
//         </Button>
//         {/* <Button
//           onClick={onConfirm}
//           // variant="contained"
//           fullWidth
//           disabled={isDeleting}
//           sx={{
//             fontFamily:'Inter',
//             textTransform: 'none',
//             borderRadius: '0.5rem',
//             bgcolor: ' rgba(202, 43, 32, 1)',
//             fontWeight: 600,
//             py: '0.5rem',
//             color:'white'
//           }}
//         >
//           {isDeleting ? <CircularProgress size={24} color="inherit" /> : 'Delete Data Source'}
//         </Button> */}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default DeleteDataSourceDialog;


import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Chip
} from '@mui/material';

// --- CHANGE 1: Define types that match the data source page ---
// This ensures the dialog can accept both Cloud and LLM data sources.
interface CloudDataSourceForDialog {
  __typename: 'DataSource';
  id: string;
  name: string;
  providerType: 'GCP' | 'AWS' | 'AZURE';
  validationStatus: 'Valid' | 'Invalid' | 'Pending' | string;
}

interface LlmDataSourceForDialog {
  __typename: 'LlmDataSource';
  id: string;
  name: string;
  providerType: 'LANGFUSE';
}

type AnyDataSourceForDialog = CloudDataSourceForDialog | LlmDataSourceForDialog;


interface DeleteDataSourceDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dataSource: AnyDataSourceForDialog | null; // Updated type
  isDeleting: boolean;
}

const getProviderIcon = (providerType: string): string => {
  switch (providerType.toUpperCase()) {
    case 'GCP': return '/icons/google-cloud-icon-2048x1646-7admxejz.svg';
    case 'LANGFUSE': return '/icons/langfuse-icon.png';
    case 'AWS': return '/icons/aws.png';
    case 'AZURE': return '/icons/azure.svg';
    default: return '';
  }
};

const getStatusChip = (status: string) => {
    const commonSx = { height: '28px', borderRadius: '40px', fontWeight: 400, width:'67px' };
    switch (status?.toLowerCase()) {
        case 'invalid': return <Chip label="Invalid" variant="outlined" size="small" sx={{ ...commonSx, color: '#CA2B20', borderColor: '#F9E9E8', border:'1px solid #CA2B20' }} />;
        case 'valid': return <Chip label="Valid" size="small" sx={{ ...commonSx, backgroundColor: '#E5F6EE', color:'#03A65A', border:'1px solid #03A65A' }} />;
        case 'pending': return <Chip label="Pending" size="small" sx={{ ...commonSx, backgroundColor: 'rgba(255, 243, 224, 1)', color: 'rgba(255, 152, 0, 1)', border:'1px solid rgba(255, 152, 0, 1)' }} />;
        default: return <Chip label={status} size="small" sx={{...commonSx, backgroundColor: 'grey.200', color: 'grey.800' }} />;
    }
};

const DeleteDataSourceDialog: React.FC<DeleteDataSourceDialogProps> = ({ open, onClose, onConfirm, dataSource, isDeleting }) => {
  if (!dataSource) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          fontFamily:'Inter', width: 600, height: 411, borderRadius: '16px', p: '0.5rem',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start',
          backgroundImage: `url('/textures/red-card-group.svg')`, backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center', backgroundSize: '100% auto',
        },
      }}
    >
      <DialogTitle sx={{ p: '1rem', flexShrink: 0 ,mt:'15px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <Box sx={{ width: '56px', height: '56px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F9E9E8', flexShrink: 0 }}>
            <img src="/icons/delete_icon.svg" alt="Delete" style={{ width: '23.33px', height: '23.33px' }} />
          </Box>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, flexGrow: 1, fontSize: '16px', lineHeight: '24px', color:'rgba(51, 51, 51, 1)' }}>
            Delete Data Source
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: '1rem',mt:'24px' }}>
        <Typography variant="body1" sx={{ fontFamily: 'Inter', fontWeight: 600, fontSize: '14px', lineHeight: '20px', mb: '0.65rem' }}>
          Do you want to delete this data source?
        </Typography>
        <Typography variant="body2" fontFamily='Inter' color=" #666666" sx={{ mb: '1.5rem',fontSize: '13px', lineHeight: '20px', fontWeight: 400 }}>
            Once you delete this data source, it will be permanently removed from the system.
        </Typography>
        <Box sx={{ border: '1px solid', borderColor: '#F9FAFB', backgroundColor: '#F9FAFB', borderRadius: '0.5rem', p: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '552px', height:'67px' }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 500,fontSize:'14px',lineHeight:'21px',color:' #333333' }}>
              {dataSource.name}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', mt: '0.25rem' }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 400,fontSize:'12px',lineHeight:'21px',color:' #666666' }}>
                Provider:
            </Typography>
                <img src={getProviderIcon(dataSource.providerType)} alt={`${dataSource.providerType} logo`} style={{ height: '1rem', width: 'auto' }} />
            </Box>
          </Box>
          {/* --- CHANGE 2: Conditionally render the status chip --- */}
          {dataSource.__typename === 'DataSource'
            ? getStatusChip(dataSource.validationStatus)
            : getStatusChip('Valid') // Langfuse sources are always considered valid
          }
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: '1rem', gap: '0.50rem', flexShrink: 0 }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ textTransform: 'none', borderRadius: '0.5rem', color: '#CA2B20', py: '0.5rem', width:'79px', height: '36px', backgroundColor:'#FCF4F4', fontWeight: 500, fontSize:'14px' }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isDeleting} sx={{ width: '162px', height: '36px', borderRadius: '8px', backgroundColor: '#CA2B20', padding: '10px 16px', gap: '4px', fontFamily:'Inter', textTransform: 'none', fontWeight: 500, fontSize:'14px', color: '#FFFFFF' }}>
          {isDeleting ? <CircularProgress size={14} color="inherit" /> : 'Delete Data Source'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDataSourceDialog;